import styled, { css } from 'styled-components';

const SliderInputWrapper = styled.div<{ disabled?: boolean }>`
  input[type='number'] {
    appearance: none;
    -moz-appearance: textfield;
  }

  ${(props) =>
    props.disabled &&
    css`
      display: none;
    `};
`;

export default SliderInputWrapper;
